import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import sniffer from 'sniffer';
import { Icon } from '@haldor/ui';

var FooterMenu = /*#__PURE__*/function (_Component) {
  _inherits(FooterMenu, _Component);

  var _super = _createSuper(FooterMenu);

  function FooterMenu() {
    _classCallCheck(this, FooterMenu);

    return _super.apply(this, arguments);
  }

  _createClass(FooterMenu, [{
    key: "render",
    value:
    /* Render methods */
    function render() {
      if (!sniffer.isDevice || sniffer.isTablet) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "footer-menu-bar-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "House"
      })), /*#__PURE__*/React.createElement("span", null, this.props.translate('nav_home')))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/schedule",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Calendar"
      })), /*#__PURE__*/React.createElement("span", null, this.props.translate('nav_schedule')))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/plans",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plans"
      })), /*#__PURE__*/React.createElement("span", null, this.props.translate('nav_plans')))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/menu",
        activeClassName: "is-active",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Burger"
      })), /*#__PURE__*/React.createElement("span", null, this.props.translate('more'))))));
    }
  }]);

  return FooterMenu;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    pathname: document.location.pathname
  };
}

export default connect(mapStateToProps, null, null, {
  pure: false
})(FooterMenu);